import { useLanguage } from "@/lib/i18n";
import { blogScanContent } from "./content";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export function BlogScanTipsFAQ() {
  const { language } = useLanguage();
  const tips = blogScanContent[language].tips;
  const conclusion = blogScanContent[language].conclusion;
  const faq = blogScanContent[language].faq;

  return (
    <section className="mx-auto max-w-[680px] px-4 sm:px-6 py-6">
      {/* Tips */}
      <h2 className="font-['Source_Serif_4'] text-2xl md:text-3xl font-semibold text-foreground mt-12 mb-5">
        {tips.title}
      </h2>

      <p className="font-['Source_Serif_4'] text-base md:text-lg leading-[1.8] text-foreground/85 mb-5">
        {tips.p1}
      </p>

      <p className="font-['Source_Serif_4'] text-base md:text-lg leading-[1.8] text-foreground/85 mb-5">
        {tips.p2}
      </p>

      <p className="font-['Source_Serif_4'] text-base md:text-lg leading-[1.8] text-foreground/85 mb-5">
        {tips.p3}
      </p>

      {/* Conclusion */}
      <h2 className="font-['Source_Serif_4'] text-2xl md:text-3xl font-semibold text-foreground mt-12 mb-5">
        {conclusion.title}
      </h2>

      <p className="font-['Source_Serif_4'] text-base md:text-lg leading-[1.8] text-foreground/85 mb-5">
        {conclusion.p1}
      </p>

      <p className="font-['Source_Serif_4'] text-base md:text-lg leading-[1.8] text-foreground/85 mb-5">
        {conclusion.p2}
      </p>

      <p className="font-['Source_Serif_4'] text-base md:text-lg leading-[1.8] text-foreground/85 mb-5">
        {conclusion.p3}
      </p>

      {/* FAQ */}
      <h2 className="font-['Source_Serif_4'] text-2xl md:text-3xl font-semibold text-foreground mt-12 mb-6">
        {faq.title}
      </h2>

      <Accordion type="single" collapsible className="w-full space-y-2">
        {(faq.items as ReadonlyArray<{ q: string; a: string }>).map(
          (item, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="border border-border/40 rounded-xl px-5 data-[state=open]:border-primary/30"
            >
              <AccordionTrigger className="font-['Source_Serif_4'] text-base md:text-lg font-semibold text-foreground text-left hover:no-underline py-4">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="font-['Source_Serif_4'] text-base leading-[1.8] text-foreground/85 pb-4">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          )
        )}
      </Accordion>
    </section>
  );
}
